module.exports = __webpack_public_path__ + "static/media/the-promised-land-mobile.6dafd2ad.jpg";